import { Checkbox, Modal, DatePicker, message } from 'antd'
import moment from 'moment';
import React, { Component } from 'react'
import API_URL from '../../../../common/url';
import Fetch from '../../../../common/Fetch';
import ExportUtil from '../../../../common/ExportUtil';
import format from '../../../shared/format';

const ChartBoxGroup = Checkbox.Group;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;
const checkOptions = [
    { label: '按区域', value: 'byArea'},
    { label: '按城市', value: 'byCity'},
    { label: '按团队领导', value: 'byLeader'},
    { label: '按人员', value: 'byUser'},
    { label: '按人员（入职≤3个月）', value: 'byNewUser'},
    { label: '按业务线', value: 'byInvLine'},
    { label: '按项目领域', value: 'byInvArea'},
    { label: '项目工时明细&访视', value: 'byWorkDetailVisit'},
]

export default class ExportModal extends Component {
    state={
        visible:false,
        exportTypes:[],
        params:{},
        exportType:null,
    }

    componentDidMount () {
        
    }

    show = (exportType, params) => {
        const { systemDate: { date } = {} } = this.context;
        this.setState({ visible: true, exportType, params:{ ...params } },() => {
            exportType  == 'chart' ? this.setQuarter(date, true): 
            this.setState({ params: { ...params, beginDate : moment(params.date).format(monthFormat), endDate: moment(params.date).format(monthFormat)} })
        })
        
    }

    handleCancel = () => {
        this.setState({ 
            visible:false,
            exportTypes:[],
            params:{},
            exportType:null,
        })
    }

    handleOk = () => {
        const { params, exportType, exportTypes} = this.state;
        const { beginDate, endDate, areaParams } = params;
        if(!beginDate || !endDate) {
            message.error('请选择日期！')
            return
        }
        if(!exportTypes || !exportTypes.length) {
            message.error('请选择导出内容！')
            return
        }
        if(exportType == 'color' && moment(endDate).diff(beginDate, 'M') > 2) {
            message.error('导出范围超出三个月，无法导出！')
            return
        }
        exportTypes.forEach(el => {
            Fetch.post(API_URL.dashboard.exportEmployeeAnalysisByDate, {
                ...params,
                ...areaParams,
                exportType:el,
            }).then(res => {
                message.success(res.success);
            });
        })
        this.handleCancel()
    }

    onChange = value => {
        this.setState({exportTypes: value})
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        if(moment(params.endDate).isBefore(params.beginDate)){
            params.endDate = params.beginDate;
        }
        this.setState({params})
    }

    disabledDate = (current, key) => {
        const { params } = this.state; 
        const currentValue = current.valueOf();
        if ( key == 'beginDate'){
            return current && (currentValue < moment(params.endDate).add(-2, 'M') || currentValue > moment(params.endDate));
        }else {
            return current && ( currentValue < moment(params.beginDate) || currentValue > moment(params.beginDate).add(2, 'M') );
        }
        
    };

    setQuarter = (date, first) => {
        const dateObj = first ? moment(date).add(-3, 'M') : moment(date)
        const year = dateObj.year();
        const quarter = dateObj.quarter();
        let offset = 0;
        // 是否是一季度， 是（年份减一，季度设为四季度）
        const isFirstQuarter = offset && quarter == 1;
        const startMonth = 1 + 3 * ((isFirstQuarter ? 3 : quarter - 1 - offset));
        const endMonth = 3 * ((isFirstQuarter ? 4 : quarter - offset));
        const { params } = this.state;
        params.beginDate = `${year - (isFirstQuarter ? 1 : 0)}-${startMonth < 10 ? `0${startMonth}` : startMonth}`;
        params.endDate = `${year- (isFirstQuarter ? 1 : 0)}-${endMonth < 10 ? `0${endMonth}` : endMonth}`;
        this.setState({ params });
    }

    render() {
        const { params, visible, exportType, exportTypes } = this.state;
        return (
            <Modal
                title="明细导出"
                width={400}
                visible={visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
            >   
                <div className='export_modal'>
                    {
                        <div>
                            <div className='title'>请选择导出范围</div>
                            <div className="filter-item">
                                <label className="filter-label">统计时间</label>
                                <MonthPicker
                                    format={monthFormat}
                                    allowClear={false}
                                    value={params.beginDate ? moment(params.beginDate) : ''}
                                    onChange={(date, dateString) =>  exportType  == 'chart' ? this.setQuarter(dateString) :  this.handleChange(dateString, 'beginDate')}
                                    style={{width: 100, verticalAlign: 'middle'}}
                                />
                                <label className="filter-label">~</label>
                                <MonthPicker
                                    format={monthFormat}
                                    allowClear={false}
                                    value={params.endDate ? moment(params.endDate) : ''}
                                    onChange={(date, dateString) =>  exportType  == 'chart' ? this.setQuarter(dateString) :  this.handleChange(dateString, 'endDate')}
                                    style={{width: 100, verticalAlign: 'middle'}}
                                />
                            </div>
                        </div>
                    }
                    
                    <div className='title'>请选择导出内容</div>
                    <ChartBoxGroup value={exportTypes} options={checkOptions} onChange={this.onChange} className="filter-item"/>
                </div>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/homePage/personIndicatorAnalysis/components/ExportModal.js